module.exports = __webpack_public_path__ + "img/北京办公室.dc6b794a.jpg";